module.exports = __webpack_public_path__ + "static/media/blue.f6dd1992.png";